import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "flex flex-col items-start" }
const _hoisted_3 = { class: "bg-primary30 rounded-[11.2px] p-2.5 mb-6" }
const _hoisted_4 = {
  viewBox: "0 0 24 24",
  fill: "white",
  class: "w-6 h-6",
  "aria-hidden": "true"
}
const _hoisted_5 = ["d"]
const _hoisted_6 = { class: "text-primary50 font-bold text-base leading-6 tracking-[0.08px]" }
const _hoisted_7 = { class: "mt-1 text-[#52526F] text-sm leading-[18px] tracking-[0.07px]" }
const _hoisted_8 = {
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6 shrink-0 text-primary30",
  "aria-hidden": "true"
}
const _hoisted_9 = ["d"]

import { mdiChevronRight } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalPanelCard',
  props: {
    icon: {},
    title: {},
    description: {},
    testId: {}
  },
  emits: ["click"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "button",
    tabindex: "0",
    class: "flex items-center justify-between gap-4 p-4 w-full border border-primary30 rounded-lg cursor-pointer bg-white hover:shadow-md transition-shadow text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-primary30",
    "data-testid": _ctx.testId,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click'))),
    onKeydown: [
      _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('click')), ["enter"])),
      _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (emit('click')), ["prevent"]), ["space"]))
    ]
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock("svg", _hoisted_4, [
          _createElementVNode("path", { d: _ctx.icon }, null, 8, _hoisted_5)
        ]))
      ]),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.title), 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.description), 1)
    ]),
    (_openBlock(), _createElementBlock("svg", _hoisted_8, [
      _createElementVNode("path", { d: _unref(mdiChevronRight) }, null, 8, _hoisted_9)
    ]))
  ], 40, _hoisted_1))
}
}

})